import { Flex, IconButton, Text, Tooltip } from "@chakra-ui/react";
import { GrAdd } from "react-icons/gr";
interface PageHead {
  name: string;
  addTooltip?: string;
  onAddModal?: () => void;
}

const PageHead = (props: PageHead) => {
  
  return (
    <Flex justifyContent="space-between" alignItems={"center"}>
      <Text padding="2" fontSize="3xl">
        {props.name}
      </Text>
      {
        props.addTooltip && props.onAddModal &&
        <Tooltip label={props.addTooltip} >
          <IconButton
            onClick={() => props.onAddModal && props.onAddModal()}
            isDisabled={false}
            icon={<GrAdd />}
            aria-label={props.addTooltip}
          />
        </Tooltip>
      }
    </Flex>
  )
}

export default PageHead;